import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import { UserProvider } from "./services/UserContext";
import { ClientProvider } from "./services/ClientContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClientProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </ClientProvider>
  </React.StrictMode>
);
